/* ============================================
   NEXTAP PRODUCT JS
   Product page: gallery, variants, form
   ============================================ */

(function() {
  'use strict';

  /* --- Product Gallery --- */
  function initProductGallery() {
    var gallery = document.querySelector('.nxt-product-gallery');
    if (!gallery) return;

    var mainImage = gallery.querySelector('.nxt-product-gallery__main-img');
    var thumbnails = gallery.querySelectorAll('.nxt-product-gallery__thumb');

    thumbnails.forEach(function(thumb) {
      thumb.addEventListener('click', function() {
        var src = this.getAttribute('data-full-src');
        var srcset = this.getAttribute('data-srcset') || '';
        if (mainImage && src) {
          mainImage.setAttribute('src', src);
          if (srcset) mainImage.setAttribute('srcset', srcset);
        }
        thumbnails.forEach(function(t) { t.classList.remove('is-active'); });
        this.classList.add('is-active');
      });

      thumb.addEventListener('keydown', function(e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          this.click();
        }
      });
    });
  }

  /* --- Quantity selector --- */
  function initQuantitySelectors() {
    document.querySelectorAll('.nxt-quantity').forEach(function(qtyWrap) {
      var input = qtyWrap.querySelector('.nxt-quantity__input');
      var minus = qtyWrap.querySelector('.nxt-quantity__minus');
      var plus = qtyWrap.querySelector('.nxt-quantity__plus');

      if (!input) return;

      if (minus) {
        minus.addEventListener('click', function() {
          var val = parseInt(input.value) || 1;
          if (val > 1) {
            input.value = val - 1;
            input.dispatchEvent(new Event('change'));
          }
        });
      }

      if (plus) {
        plus.addEventListener('click', function() {
          var val = parseInt(input.value) || 1;
          var max = parseInt(input.getAttribute('max')) || 99;
          if (val < max) {
            input.value = val + 1;
            input.dispatchEvent(new Event('change'));
          }
        });
      }
    });
  }

  /* --- Sticky product buy bar --- */
  function initStickyBuyBar() {
    var buyBar = document.querySelector('.nxt-sticky-buy-bar');
    var productForm = document.querySelector('.nxt-product-info');
    if (!buyBar || !productForm) return;

    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (!entry.isIntersecting) {
          buyBar.classList.add('is-visible');
        } else {
          buyBar.classList.remove('is-visible');
        }
      });
    }, { rootMargin: '-100px 0px 0px 0px' });

    observer.observe(productForm);
  }

  /* --- Image zoom on hover (desktop) --- */
  function initImageZoom() {
    var zoomContainers = document.querySelectorAll('.nxt-product-gallery__main');

    zoomContainers.forEach(function(container) {
      var img = container.querySelector('.nxt-product-gallery__main-img');
      if (!img) return;

      container.addEventListener('mousemove', function(e) {
        if (window.innerWidth < 990) return;
        var rect = container.getBoundingClientRect();
        var x = ((e.clientX - rect.left) / rect.width) * 100;
        var y = ((e.clientY - rect.top) / rect.height) * 100;
        img.style.transformOrigin = x + '% ' + y + '%';
        img.style.transform = 'scale(1.8)';
      });

      container.addEventListener('mouseleave', function() {
        img.style.transform = 'scale(1)';
      });
    });
  }

  function init() {
    initProductGallery();
    initQuantitySelectors();
    initStickyBuyBar();
    initImageZoom();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  if (Shopify.designMode) {
    document.addEventListener('shopify:section:load', init);
  }
})();
